import { render, staticRenderFns } from "./MainActions.vue?vue&type=template&id=53a077ee&scoped=true"
import script from "./MainActions.vue?vue&type=script&lang=js"
export * from "./MainActions.vue?vue&type=script&lang=js"
import style0 from "./MainActions.vue?vue&type=style&index=0&id=53a077ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a077ee",
  null
  
)

export default component.exports